import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { stateProps } from "../types";
import { useLocation } from "react-router-dom";
import MainContainer from "./common/mainContainer.component";
import Header from "./common/header.component";
import Footer from "./common/footer.component";
import Home from "./home.component";
import Title from "./title.component";
import Thank from "./thank.component";
import Name from "./name.component";
import Gender from "./gender.component";
import Email from "./email.componet";
import PhoneNum from "./phone.component";
import Languages from "./languages.component";
import Degree from "./degree.component";
import Qualifications from "./qualifications.componet";
import Price from "./price.component";
import TimeSlot from "./timeslot.component";
import RegisterNum from "./register.number.component";
import Speciality from "./speciality.component";
import BoardCertified from "./boardCertified.component";
import Practise from "./practise.locations.component";
import BankName from "./bank.name.component";
import BranchName from "./branch.name.component";
import AccntHolder from "./account.holder.component";
import AccntNum from "./account.number.component";
import Signature from "./signature.component";
import Profile from "./profile.component";
import NIC from "./nic.component";
import Seal from "./seal.component";
import SLMCCertificate from "./slmcCertificate.component";
import SLMCID from "./slmcID.component";
import ProofOfQualification from "./proofOfQualification.component";
import TermsAndCondition from "./termsAndCondition.component";
import Loading from "./loading.component";
import { onChangeErrorStatus } from "../actions/index";
import AlertBox from "./common/alertBox.component";

const Navigation: React.FC = () => {
  const dispatch = useDispatch();

  const { step, doctorCreateStatus, errorData, errorDataSubmit, specialities, languages } =
    useSelector((state: { router: History; doctorInfo: stateProps }) => state.doctorInfo);

  var jwt = require("jsonwebtoken");
  const search = useLocation().search;
  const token = new URLSearchParams(search).get("token");
  let valid: boolean;
  let errorStatusData: { status: boolean; msg: string };
  const secret_key = process.env.REACT_APP_JWT_SECRET;

  if (token !== null) {
    try {
      jwt.verify(token, secret_key);
      errorStatusData = {
        status: false,
        msg: "",
      };
      if (specialities.length > 0 && languages.length > 0) {
        valid = true;
      } else {
        valid = false;
      }
    } catch (err) {
      valid = false;
      // Have to Error Display
      errorStatusData = {
        status: true,
        msg: "Token Invalid !!!",
      };
    }
  } else {
    valid = false;
    errorStatusData = {
      status: true,
      msg: "Token Must Provide !!!",
    };
  }
  if (errorData.status !== errorStatusData.status || errorData.msg !== errorStatusData.msg) {
    dispatch(onChangeErrorStatus(errorStatusData.status, errorStatusData.msg));
  }

  if (valid) {
    if (step === 0) {
      return <Home />;
    } else if (step === 1) {
      return <WithHeaderAndFooter component={Title} />;
    } else if (step === 2) {
      return <WithHeaderAndFooter component={Name} />;
    } else if (step === 3) {
      return <WithHeaderAndFooter component={Gender} />;
    } else if (step === 4) {
      return <WithHeaderAndFooter component={Email} />;
    } else if (step === 5) {
      return <WithHeaderAndFooter component={PhoneNum} />;
    } else if (step === 6) {
      return <WithHeaderAndFooter component={Languages} />;
    } else if (step === 7) {
      return <WithHeaderAndFooter component={Degree} />;
    } else if (step === 8) {
      return <WithHeaderAndFooter component={Qualifications} />;
    } else if (step === 9) {
      return <WithHeaderAndFooter component={Price} />;
    } else if (step === 10) {
      return <WithHeaderAndFooter component={TimeSlot} />;
    } else if (step === 11) {
      return <WithHeaderAndFooter component={RegisterNum} />;
    } else if (step === 12) {
      return <WithHeaderAndFooter component={Speciality} />;
    } else if (step === 13) {
      return <WithHeaderAndFooter component={BoardCertified} />;
    } else if (step === 14) {
      return <WithHeaderAndFooter component={Practise} />;
    } else if (step === 15) {
      return <WithHeaderAndFooter component={BankName} />;
    } else if (step === 16) {
      return <WithHeaderAndFooter component={BranchName} />;
    } else if (step === 17) {
      return <WithHeaderAndFooter component={AccntHolder} />;
    } else if (step === 18) {
      return <WithHeaderAndFooter component={AccntNum} />;
    } else if (step === 19) {
      return <WithHeaderAndFooter component={Signature} />;
    } else if (step === 20) {
      return <WithHeaderAndFooter component={Profile} />;
    } else if (step === 21) {
      return <WithHeaderAndFooter component={NIC} />;
    } else if (step === 22) {
      return <WithHeaderAndFooter component={Seal} />;
    } else if (step === 23) {
      return <WithHeaderAndFooter component={SLMCCertificate} />;
    } else if (step === 24) {
      return <WithHeaderAndFooter component={SLMCID} />;
    } else if (step === 25) {
      return <WithHeaderAndFooter component={ProofOfQualification} />;
    } else if (step === 26) {
      return (
        <WithHeaderAndFooter component={TermsAndCondition} errorDataSubmit={errorDataSubmit} />
      );
    } else if (step === 27) {
      // have to check states here as well
      if (doctorCreateStatus === true) return <Thank />;
      return <Loading />;
    }
  } else {
    return <Home />;
  }
  return <Home />;
};

export default Navigation;

const WithHeaderAndFooter = ({
  component: Component,
  errorDataSubmit,
}: {
  component: React.FC;
  errorDataSubmit?: { status?: boolean; msg?: string };
}) => {
  return (
    <>
      <MainContainer>
        {errorDataSubmit && errorDataSubmit.status && (
          <AlertBox alertTitle={errorDataSubmit.msg} onForm={true} />
        )}
        <Header />
        <Component />
        <Footer />
      </MainContainer>
    </>
  );
};
